const map = {
	"./Andela_logo.jpeg": 3058,
	"./Cmu-logo.png": 1389,
	"./Conferences/AfriCHI/Egypt1.jpg": 9607,
	"./Conferences/AfriCHI/Egypt2.jpg": 1208,
	"./Conferences/AfriCHI/Egypt3.jpg": 8373,
	"./Conferences/ICTD/Kenya1.jpg": 8658,
	"./Conferences/ICTD/Kenya2.jpg": 2813,
	"./Conferences/Usenix/main.jpeg": 7999,
	"./Conferences/Usenix/usenix1.jpg": 6458,
	"./Conferences/Usenix/usenix2.jpg": 9061,
	"./Conferences/Usenix/usenix3.jpeg": 7073,
	"./Conferences/Usenix/usenix4.jpeg": 4788,
	"./Conferences/Usenix/usenix5.jpg": 4590,
	"./ICTD.png": 954,
	"./UR.jpeg": 216,
	"./UR_LOGO.jpeg": 4294,
	"./address_image.svg": 3906,
	"./animated_logo.svg": 9083,
	"./blogs_image.svg": 7245,
	"./cisco.jpeg": 9438,
	"./citi.png": 9163,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./contactMail.png": 3189,
	"./coursera.png": 4922,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./flexplatforms.png": 795,
	"./freecodecamp.png": 3000,
	"./freecopy_logo.png": 4633,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./ibm_logo.png": 262,
	"./intel_logo.jpg": 8504,
	"./jsFramework.svg": 9655,
	"./legato_logo.png": 1236,
	"./location.png": 7875,
	"./manOnTable.svg": 7473,
	"./microsoft_logo.png": 752,
	"./mozilla_logo.png": 6816,
	"./muffito_logo.png": 9556,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./portfolio.gif": 8467,
	"./profile.jpg": 2243,
	"./profilepic.png": 811,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pwa.png": 9180,
	"./sci.png": 1935,
	"./stanford_logo.png": 6691,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./uchicago.png": 2277,
	"./ui_ux_design.svg": 1544,
	"./usenix.png": 6696
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;